import { Skeleton } from '@skin-seoul/design-system';
import React from 'react';

interface VerticalProductCardSkeletonProps {
  className?: string;
  width?: string;
}

export const VerticalProductCardSkeleton = ({ className, width }: VerticalProductCardSkeletonProps) => {
  return (
    <div className={`flex flex-col gap-2 desktop:gap-4 cursor-pointer min-w-0 ${className || ''}`} style={{ width: width || '100%' }}>
      <Skeleton className="w-full h-[200px] tablet:h-[300px] rounded-[8px] overflow-hidden min-w-[0px] relative" />

      <div className="flex flex-col gap-3 w-full min-w-0 rounded-b-[8px]">
        <div className="flex flex-col gap-2 w-full min-w-0">
          <Skeleton className="w-[120px] h-[16px] rounded-[4px]" />
          <Skeleton className="w-full h-[16px] rounded-[4px]" />
        </div>

        <div className="flex flex-row items-center gap-2">
          <Skeleton className="w-[80px] h-[20px] rounded-[4px]" />
          <Skeleton className="w-[40px] h-[20px] rounded-[4px]" />
        </div>

        <div className="flex items-center gap-2">
          <Skeleton className="w-[60px] h-[16px] rounded-[4px]" />
        </div>
      </div>
    </div>
  );
};
